import { request } from './index'
import $store from '@/store/index'

export const initConfig = data => {
  return request({
    url: '/media-hub/base/initConfig',
    method: 'GET',
    params: data,
    noNeedCheck: true,
    notifyTitle: 'Get Config'
  })
}

export const checkThumbnail = data => {
  return request({
    url: `${location.protocol}//${$store.state.initConfig.blobUrl.split('/')[0]}/thumbnailVersion`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Check Thumbnail'
  })
}

export const checkCNThumbnail = data => {
  return request({
    url: `${location.protocol}//${$store.state.initConfig.cnBlobUrl.split('/')[0]}/thumbnailVersion`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Check CN Thumbnail'
  })
}

export const userInfo = data => {
  return request({
    url: '/media-hub/user/getUserInfo',
    method: 'GET',
    params: data,
    notifyTitle: 'Get User Info'
  })
}

// 支持传入额外 axios 配置（如 AbortController signal） [Claude Code]
export const setBehavior = (data, extraConfig = {}) => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/userBehavior`,
    method: 'POST',
    data,
    notifyTitle: 'Set Behavior',
    ...extraConfig
  })
}
export const getBehavior = data => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/userBehavior`,
    method: 'GET',
    params: data,
    notifyTitle: 'Get Behavior'
  })
}

export const checkLoginInfo = data => {
  return request({
    url: '/media-hub/base/loginUserInfo',
    method: 'GET',
    params: data,
    notifyTitle: 'Check Login Info'
  })
}

export const getDefaultInfo = data => {
  return request({
    url: '/media-hub/base/welcomeData',
    method: 'GET',
    params: data,
    notifyTitle: 'Get Welcome Data'
  })
}

export const checkRoleAndToken = data => {
  return request({
    url: '/media-hub/base/getRoleAndRefreshToken',
    method: 'GET',
    params: data,
    noNeedCheck: true,
    notifyTitle: 'Refresh Token'
  })
}

export const getRoleAndUserInfo = (data) => {
  return request({
    url: '/media-hub/base/getRoleAndUserInfo',
    method: 'GET',
    params: data,
    notifyTitle: 'Get Role Info'
  })
}

// ${location.protocol}//${$store.state.initConfig.blobUrl.split('/')[0]}
export const checkFirstLogin = data => {
  return request({
    url: `${$store.state.initConfig.userGroupFrontUrl}/user-group/noAuth/checkServiceFirstLogin`,
    method: 'GET',
    params: data,
    notifyTitle: 'Check First Login'
  })
}

export const getUserTagKey = data => {
  return request({
    url: '/media-hub/base/get/userTagKey',
    method: 'GET',
    params: data,
    notifyTitle: 'Get Tag Key'
  })
}

export const logoutFn = data => {
  return request({
    url: '/media-hub/logOut',
    method: 'GET',
    params: data,
    notifyTitle: 'Logout'
  })
}

export const checkRootGroupAgent = data => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/agent/listAgentBox`,
    method: 'GET',
    params: data,
    notifyTitle: 'List Agent Box'
  })
}

export const getGroupPreviewSetting = data => {
  return request({
    url: '/media-hub/project/group/settings',
    method: 'GET',
    params: data,
    notifyTitle: 'Get Group Settings'
  })
}

export const setGroupPreviewSetting = data => {
  return request({
    url: '/media-hub/project/group/setting',
    method: 'POST',
    data,
    notifyTitle: 'Save Group Settings'
  })
}

export const checkUserAuth = data => {
  return request({
    url: '/media-hub/common/checkAuth',
    method: 'GET',
    params: data,
    disabledErrorTips: true,
    notifyTitle: 'Check User Auth'
  })
}
